export const environment = {
  env: 'prod',
  production: true,
  apiServer: {
    domain: 'api-licensing.cefla.it', //
    protocol: 'https',
    wsProtocol: 'ws',
    port: 443,
  },
  apiSocket: {
    domain: 'api-licensing.cefla.it', //
    protocol: 'https',
    wsProtocol: 'wss',
    port: 3896,
  },
  connectSocket: true,
  baseUrl: 'https://licensing.cefla.it/',
  // sentryEnv: 'prod',
  // sentryDsn: 'https://a9fd9f7d6c3be1765c05c719e892f80d@o4506478027866112.ingest.us.sentry.io/4508733693100032',
  appVersion: '1.0.0',
  reCaptchaKey: '6Lf54OInAAAAAGSd1RAM7X_8ogL7I2GAxITfPYUm',
  JWT_PUBLIC_KEY:
    '-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtX49jyJHQN5jUJ7qSWxq\n5b0EQlRdGH6J8hNNhOL4FajKAS3h1/mT7unCM5h7bOmbTVMhjb2DWBCcFvX/FT7f\nsbJGGhLXDcqymnVXjK6p4VVUdpwj5BeUgyK2Y+HrPRnHQJxUKs0NKEyTgRO7h2iv\n6f0n5ODgeX/bmrcjdlU6IyY38Zlmnt8hl3mNPx9Uh8H62vOKgEMAIgIRA5aNuk57\nHPmtVLOTVJlRf7TV2piDKrCSarTnX2xDvgbIL64TJjjdoGB6XW+XfI1VpBL543Ur\ncU5ENAwlQ7yxDPH7TtaLIGzS7cyNLThv8DjoB1hR0+4kNq/t9aLq4DYI5eWVQ3lt\nvwIDAQAB\n-----END PUBLIC KEY-----',
};
